import React from 'react';
import { Global } from '@emotion/react';
import top from '@/assets/betblast/images/background/bgTop.png';

export default function index() {
  return (
    <Global
      styles={{
        body: {
          backgroundImage: `url(${top}), linear-gradient(180deg, var(--bc-colors-alpha-700), var(--bc-colors-alpha-900))`,
          backgroundPosition: 'top, center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: '100vw',
          '@media (max-width: 767px)': {
            background: `linear-gradient(180deg, var(--bc-colors-alpha-700), var(--bc-colors-alpha-900))`,
          },
        },
      }}
    />
  );
}
